
export default {
  name: "TotalizadorContasHoje",
  props: {
    totaisFinanceiros: {
      type: Object,
      default: () => ({
        totalPagarHoje: 0,
        totalReceberHoje: 0,
      }),
    },
    loading: { type: Boolean, default: false },
    error: { type: String, default: null },
  },
  computed: {
    totalPagarHoje() {
      return Number(this.totaisFinanceiros?.totalPagarHoje ?? 0);
    },
    totalReceberHoje() {
      return Number(this.totaisFinanceiros?.totalReceberHoje ?? 0);
    },
  },
  methods: {
    formatCurrency(v) {
      try {
        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        }).format(v ?? 0);
      } catch {
        return `R$ ${(v ?? 0).toFixed(2)}`;
      }
    },
  },
};
